import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { streamChat, getSession } from "./assistApi";

const KEY = "clipx_assist_session";

export const useAssist = (t) => {
  const { pathname } = useLocation();
  const [sessionId, setSessionId] = useState(() => localStorage.getItem(KEY));
  const [messages, setMessages] = useState([]);
  const [ticketId, setTicketId] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async (id) => {
    if (!id) { setMessages([]); setTicketId(null); return; }
    try {
      const s = await getSession(id);
      setMessages(s.messages);
      setTicketId(s.ticket_id);
    } catch { localStorage.removeItem(KEY); setSessionId(null); setMessages([]); }
  }, []);

  useEffect(() => { load(sessionId); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const pick = (id) => { setSessionId(id); if (id) localStorage.setItem(KEY, id); else localStorage.removeItem(KEY); load(id); };

  const send = async (text) => {
    if (!text.trim() || busy) return;
    setBusy(true);
    setMessages((m) => [...m, { role: "user", text }, { role: "assistant", text: "" }]);
    const patch = (fn) => setMessages((m) => { const c = [...m]; c[c.length - 1] = fn(c[c.length - 1]); return c; });
    try {
      await streamChat({
        message: text, sessionId, page: pathname,
        onSession: (id) => { setSessionId(id); localStorage.setItem(KEY, id); },
        onDelta: (d) => patch((x) => ({ ...x, text: x.text + d })),
        onError: (e) => patch((x) => ({ ...x, text: e, error: true })),
      });
    } catch (e) {
      patch((x) => ({ ...x, text: e.message || t("as.err"), error: true }));
    }
    setBusy(false);
  };

  return { sessionId, messages, ticketId, setTicketId, busy, send, pick };
};
